// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.externaldata.UpdateExternalDataRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateExternalDataRequest extends GandalfModelBase {

	@GandalfLabel('Comments')
	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfLabel('ExternalData')
	@GandalfValidator({ notNull: { message: 'ExternalData is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	externalDataId!: number;

	@GandalfConstantDecorator(constants.ExternalDataSource)
	@GandalfLabel('Source')
	@GandalfValidator({ notNull: { message: 'Source is required' } })
	@GandalfProperty({ designType: constants.ExternalDataSource, isRequired: true })
	externalDataSource!: constants.ExternalDataSource;

	@GandalfLabel('URL')
	@GandalfValidator({ sizeString: { message: 'URL cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	externalDataSourceText!: string | null;

	@GandalfLabel('Name')
	@GandalfValidator({ notNull: { message: 'Name is required' } })
	@GandalfValidator({ sizeString: { message: 'Name must be between 1 and 255 characters', minLength: 1, maxLength: 255 } })
	@GandalfProperty({ designType: String, isRequired: true })
	name!: string;

	@GandalfLabel('Request Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	requestDate!: Date | null;

	@GandalfConstantDecorator(constants.ExternalDataStatus)
	@GandalfLabel('Status')
	@GandalfValidator({ notNull: { message: 'Status is required' } })
	@GandalfProperty({ designType: constants.ExternalDataStatus, isRequired: true })
	status!: constants.ExternalDataStatus;

}
